/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_SubtitleInputs */

const es_components_upgrade_plan_modal_subtitle = /** @type {(inputs: Components_Upgrade_Plan_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podés cambiar o escalar tu plan en cualquier momento.`)
};

const en_components_upgrade_plan_modal_subtitle = /** @type {(inputs: Components_Upgrade_Plan_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can change or upgrade your plan at any time.`)
};

/**
* | output |
* | --- |
* | "You can change or upgrade your plan at any time." |
*
* @param {Components_Upgrade_Plan_Modal_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_subtitle = /** @type {((inputs?: Components_Upgrade_Plan_Modal_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_subtitle(inputs)
	return en_components_upgrade_plan_modal_subtitle(inputs)
});
export { components_upgrade_plan_modal_subtitle as "components.upgrade_plan_modal.subtitle" }